export default "__VITE_ASSET__C4Zi$5Dr__"